import axios from 'axios';
import * as qs from 'qs';
import * as Promise from 'bluebird';

import { API_USERS, API_CLASSROOMS } from '../../services/api/apiConst';
import { ROLE } from '../../const';

export const getParticipantsPage = async (institutionId, excludedClassroomId, page, perPage, query, role) => {
  const teachersQuery = {
    institutionId,
    excludedClassroomId,
    page,
    perPage,
    query,
    role
  };
  const url = `${API_USERS}?${qs.stringify(teachersQuery)}`;
  const teachersPage = await axios.get(url);

  return teachersPage.data;
};

export const postNewParticipants = async (participants, classroomId, selectedRole) => {
  const promises = participants.map(user => {
    const url = `${API_CLASSROOMS}/${classroomId}/users/${user._id}`;

    return axios.post(url, { role: selectedRole });
  });

  Promise.all(promises);
};

export const editRoleClassroom = (classroomId, userId, selectedUserRole) => {
  const url = `${API_USERS}/${userId}/classroom/${classroomId}/role`;
  const role = selectedUserRole === ROLE.INSTRUCTOR ? ROLE.COINSTRUCTOR : ROLE.INSTRUCTOR;

  return axios.put(url, { role });
};
